import axios from 'axios';

class DragonBabyApi {
  constructor(access_token) {
    this.api = axios.create({
      baseURL: process.env.REACT_APP_BACKEND_URI,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': access_token
      }
    });
    ;
  }

  getGroupByLineId(line_id) {
    return this.api.get(`api/v1/groups?line_id=${line_id}`)
  }

  exchangeToken(token, data) {
    return this.api.post(`api/v1/tokens`, { ...data, access_token: token, stub_user_id: process.env.REACT_APP_STUB_USER_ID })
  }

  getExchangeRates() {
    return this.api.get(`api/v1/exchange_rates`)
  }

  getCurrencies() {
    return this.api.get(`api/v1/currencies`)
  }

  getPayments(group_id, accounting_book_id, query) {
    return this.api.get(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}/payments${query}`)
  }

  getPayment(group_id, accounting_book_id, payment_id) {
    return this.api.get(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}/payments/${payment_id}`)
  }

  deletePayments(group_id, accounting_book_id, body) {
    return this.api.post(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}/payments/destroy_all`, body)
  }

  createPayment(group_id, accounting_book_id, params) {
    return this.api.post(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}/payments`, { payment: params })
  }

  exportPayments(group_id, accounting_book_id) {
    return this.api.post(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}/payments/export`)
  }

  updateUser(group_id, user_id, params) {
    return this.api.patch(`api/v1/groups/${group_id}/users/${user_id}`, params)
  }

  deleteUser(group_id, user_id, params) {
    return this.api.delete(`api/v1/groups/${group_id}/users/${user_id}`)
  }

  createUser(group_id, params) {
    return this.api.post(`api/v1/groups/${group_id}/users`, params)
  }

  getUsers(group_id, options = {}) {
    const query = options.includeHidden ? '?include_hidden=true' : ''
    return this.api.get(`api/v1/groups/${group_id}/users${query}`)
  }

  hideUser(group_id, user_id) {
    return this.api.patch(`api/v1/groups/${group_id}/users/${user_id}/hide`)
  }

  restoreUser(group_id, user_id) {
    return this.api.patch(`api/v1/groups/${group_id}/users/${user_id}/restore`)
  }

  getCurrentAccountingBook(group_id) {
    return this.api.get(`api/v1/groups/${group_id}/accounting_books/current`)
  }

  getAccountingBookSummary(group_id, accounting_book_id) {
    return this.api.get(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}/summary`)
  }

  getAccountingBook(group_id, accounting_book_id) {
    return this.api.get(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}`)
  }

  getAccountingBooks(group_id) {
    return this.api.get(`api/v1/groups/${group_id}/accounting_books`)
  }

  createAccountingBook(group_id, params) {
    return this.api.post(`api/v1/groups/${group_id}/accounting_books`, { accounting_book: params })
  }

  updateAccountingBook(group_id, accounting_book_id, params) {
    return this.api.patch(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}`, params)
  }

  updateCurrentAccountingBook(group_id, accounting_book_id) {
    return this.api.post(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}/set_as_current`)
  }

  deleteAccountingBook(group_id, accounting_book_id) {
    return this.api.delete(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}`)
  }

  getDeletedAccountingBooks(group_id) {
    return this.api.get(`api/v1/groups/${group_id}/accounting_books/deleted`)
  }

  restoreAccountingBook(group_id, accounting_book_id) {
    return this.api.patch(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}/restore`)
  }

  updateCoverCostUsers(group_id, accounting_book_id, ids) {
    return this.api.post(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}/users`, { accounting_book_user_ids: ids })
  }

  updateCoverCostUser(group_id, accounting_book_id, ids) {
    return this.api.post(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}/user`, { accounting_book_user_ids: ids })
  }

  getLogMessages(group_id, accounting_book_id) {
    return this.api.get(`api/v1/groups/${group_id}/accounting_books/${accounting_book_id}/log_messages`)
  }
}

const createDragonBabyApi = (token) => {
  return new DragonBabyApi(token);
}

export { createDragonBabyApi };
